/**
 * @generated SignedSource<<af34f019ba9d57acdd0a9174290b30a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type applePayCheckout_viewer$data = {
  readonly clientToken: {
    readonly value: string | null;
  } | null;
  readonly " $fragmentType": "applePayCheckout_viewer";
};
export type applePayCheckout_viewer$key = {
  readonly " $data"?: applePayCheckout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"applePayCheckout_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "applePayCheckout_viewer"
};

(node as any).hash = "802aebf0e9759c5bfe01a8f8b3938e91";

export default node;
